import { render, staticRenderFns } from "./ProductTracker.vue?vue&type=template&id=3763cb3c"
import script from "./ProductTracker.vue?vue&type=script&lang=js"
export * from "./ProductTracker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports